var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 75.12499 30.29112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a {\r\n        fill: none;\r\n      }\r\n\r\n      .b {\r\n        clip-path: url(#a);\r\n      }\r\n\r\n      .c {\r\n        fill: #df579f;\r\n      }\r\n\r\n      .d {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-667.99787 -654.71854)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 560.21047,
    y: 497.52233,
    width: 178.58289,
    height: 263.62201
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M667.99787,683.88453a57.49241,57.49241,0,0,1,8.646.213c3.533.338,3.826.922,9.772.912a11.36619,11.36619,0,0,0,4.188-1.054l52.519-21.598-3.086-7.639Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M687.9043,676.61523a10.01546,10.01546,0,0,1,1.499-.74609,2.76092,2.76092,0,0,1,1.96094-.18848,1.80991,1.80991,0,0,1,1.07422,1.085,1.98071,1.98071,0,0,1,.05761,1.5293,2.78907,2.78907,0,0,1-1.63183,1.457,3.01222,3.01222,0,0,1-.67188.207l1.01172,2.502-.80664.32617Zm2.02246,2.68555a2.89956,2.89956,0,0,0,.69336-.20508c.97363-.39258,1.376-1.10547,1.02734-1.96679-.333-.8252-1.07812-.98829-1.96777-.62793a3.59538,3.59538,0,0,0-.7334.37207Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M692.7793,674.55859l.80566-.32519,2.25,5.56933,2.66992-1.07812.27344.67578-3.47559,1.4043Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M700.21777,676.5332l.14649,2.22657-.834.33593-.40136-7.10156.97265-.39355,4.65528,5.38379-.86231.3496-1.46191-1.69531Zm1.79395-1.459-1.33692-1.54883c-.30371-.35156-.54687-.68555-.78613-1.00977l-.01855.00782c.05761.4082.10937.8291.14258,1.25781l.11816,2.05273Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M706.53906,676.26465l-1.07129-2.65039-3.42578-2.79785.917-.3711,1.57813,1.36817c.43164.376.76953.68066,1.13965,1.03711l.01953-.00684c.01074-.47852.05957-.97266.10937-1.543l.20215-2.08594.918-.37109-.64551,4.43164,1.07422,2.66016Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M707.56738,668.584l3.36328-1.35937.27344.67676-2.55859,1.03418.83887,2.07617,2.36328-.95508.26953.667-2.36328.9541,1.1416,2.82618-.80469.32617Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M712.8877,666.43359l1.49414,3.69922c.56543,1.39844,1.42578,1.74024,2.25976,1.40235.92676-.37305,1.27246-1.22461.71485-2.60547l-1.49415-3.69727.81641-.33008,1.4707,3.64258c.77539,1.918.084,3.11328-1.26953,3.66016-1.27832.51758-2.53808.17383-3.32031-1.76367l-1.48633-3.67774Z",
    transform: "translate(-667.99787 -654.71854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M718.044,664.35156l.80566-.32617,2.25,5.57031,2.66992-1.08008.27246.67774-3.47461,1.40332Z",
    transform: "translate(-667.99787 -654.71854)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayful);
export default __webpack_public_path__ + "static/media/Playful.33fbaa997e131efa562112e412b0292d.svg";
export { ForwardRef as ReactComponent };